module.exports = __webpack_public_path__ + "img/worst-disabled.16a982f7.svg";